//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd January 2018
//  * @type            TopBar Component File
//  * @description -   This file renders the html and functionality for topbar in app.
<template>
  <div class="col-md-12 p-0">
    <v-wait for="topbarloader" class="height-zero">
      <template slot="waiting">
        <div id="designLoadingdiv" class="loadingDiv_analytics">
            <div class="loadersec">
              <div class="loader"></div>
            </div>
        </div>
      </template>
    </v-wait>
    <div class="survey_head_row">
      <div class="survey_head_left">
        <i class="fa fa-star" aria-hidden="true" v-if="all.in_survey_favourite == 1"></i>
        <i class="fa fa-file-text-o" aria-hidden="true" v-else-if="all.in_status == 1"></i>
        <i class="fa fa-pencil" aria-hidden="true" v-else-if="all.in_status == 5"></i>
        <i class="fa fa-file-text-o" aria-hidden="true" v-else></i>
        <input
          maxlength="255"
          :value="all.st_survey_name"
          @blur="updateSurvey_name"
          id="survey_name"
          data-toggle="tooltip"
          data-placement="top"
          :title="all.st_survey_name"
        />
        <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
      </div>
      <div class="survey_head_right pull-right">

        <button
          v-if="questionPanelActive && !isSkipLogic"
          type="button"
          class="btn btn-survey-reguler btn-save-survey btn-header-question-save"
          aria-label="Save question"
          @click.prevent="triggerQuestionSave"
        >
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="m486.996094 64.382812-39.378906-39.378906c-16-16.023437-37.695313-25.003906-60.332032-25.003906h-328.617187c-32.40625 0-58.667969 26.261719-58.667969 58.667969v394.664062c0 32.40625 26.261719 58.667969 58.667969 58.667969h394.664062c32.40625 0 58.667969-26.261719 58.667969-58.667969v-328.617187c0-22.636719-8.980469-44.332032-25.003906-60.332032zm-401.664063 68.949219v-53.332031c0-8.832031 7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16v53.332031c0 8.832031-7.167969 16-16 16h-224c-8.832031 0-16-7.167969-16-16zm170.667969 293.335938c-53.011719 0-96-42.988281-96-96 0-53.015625 42.988281-96 96-96s96 42.984375 96 96c0 53.011719-42.988281 96-96 96zm0 0"/>
          </svg>
          <span>save</span>
        </button>
        <button v-if="all.in_status !== vueCommonConfig.SURVEY_PUBLISHED"
          class="btn btn-survey-reguler btn-publish-survey"
          @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : validatePublish()"
          >
		  	<i :class="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? 'fa fa-floppy-o' : 'fa fa-rocket'" aria-hidden="true"></i>
			<span>publish</span>
          </button>
        <button
          :disabled="loadingSurveyDetails"
          class="btn btn-survey-reguler btn-preview-survey"
          @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : previewWindow()"
        >
			<i class="fa fa-eye" aria-hidden="true"></i>
			<span>preview</span>
		</button>
        <button
          v-if="showTracey"
          type="button"
          class="btn btn-survey-reguler btn-tracey-ai"
          aria-label="Ask Tracey"
          @click="$emit('toggle-tracey')"
        >
          <span class="btn-tracey-ai__icon-slot" aria-hidden="true">
            <svg class="btn-tracey-ai__icon" viewBox="0 0 24 24">
              <path d="M12 4l2.4 5.6L20 12l-5.6 2.4L12 20l-2.4-5.6L4 12l5.6-2.4L12 4z"></path>
            </svg>
            <img
              class="btn-tracey-ai__face"
              :src="aiButImg"
              alt=""
              width="24"
              height="24"
            />
          </span>
          <span>Ask Tracey</span>
        </button>
        <!-- :disabled="all.in_status === vueCommonConfig.SURVEY_PUBLISHED" -->
        <button
          class="btn btn-survey-reguler btn-save-survey btn-cancel"  
          @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : exitVue()"
        >
			<i class="fa fa-times" aria-hidden="true"></i>
			<span>Close</span>
		</button>

        <div class="dropdown topheaderdropdown" v-show="all.in_status === vueCommonConfig.SURVEY_PUBLISHED || all.in_survey_type !== 2">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <i class="fa fa-ellipsis-v" aria-hidden="true"></i> -->
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
                <g>
                  <g>
                    <circle cx="256" cy="256" r="64"/>
                    <circle cx="256" cy="448" r="64"/>
                    <circle cx="256" cy="64" r="64"/>
                  </g>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
            </svg>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button
              style="cursor: pointer;"
              v-if="all.in_survey_type !== 2"
              :disabled="all.in_survey_type == 2 ? true : false"
              class="dropdown-item"
              @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : shareSurvey()">
              <i class="fa fa-share-alt" aria-hidden="true"></i> Share Form</button>
              <div v-if="all.in_status === vueCommonConfig.SURVEY_PUBLISHED">
                <a target="_blank" class="dropdown-item" :href="assignUsersLink"><i class="fa fa-tag" aria-hidden="true"></i> Assign Users to Form</a>
                <a v-if="(all.in_survey_type == 1 || all.in_survey_type == 3)" target="_blank" class="dropdown-item" :href="responseLink"><i class="fa fa-plus" aria-hidden="true"></i> Add Response to Form</a>
                <a target="_blank" class="dropdown-item" :href="surveySettingsLink"><i class="fa fa-cog" aria-hidden="true"></i> Form Settings</a>
              </div>
          </div>
        </div>
        <!-- <button
          v-else
          class="btn btn-survey-reguler btn-publish-survey"
          @click="validatePublish"
        >publish</button>-->
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal
      id="shareModal"
      size="xl"
      ref="myModalRef"
      title="Share Form"
      hide-footer
      no-enforce-focus
    >
      <div slot="modal-title">Share Form</div>
      <div class="modal-body-content">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab active>
              <template slot="title">
                <i class="fa fa-link" aria-hidden="true"></i>
                <strong>Link</strong>
              </template>
              <div class="form-group inputWrapper">
                <div class="label-inputs col-sm-12 col-xs-10">
                  <input
                    :value="responseLink"
                    type="text"
                    tabindex="2"
                    class="form-control form-control-new"
                    id="shareLink"
                    :title="responseLink"
                    readonly
                  />
                </div>
                <div class="label-inputs label-inputs-new">
                  <a class="share-button" href="#" @click.prevent="copyText">
                    <span class="share-button-span">
                      <i class="fa fa-files-o" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
              </div>
            </b-tab>
            <b-tab title="Email">
              <template slot="title">
                <i class="fa fa-envelope-square" aria-hidden="true"></i>
                <strong>Email</strong>
              </template>
              <form>
                <div class="noreply-label form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">From:</label>
                  <div
                    style="color: #7a7575;"
                    class="label-inputs col-sm-10 col-xs-10"
                  >{{shareDetails.company_details}}</div>
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2"></label>
                  <label
                    class="col-sm-10 col-xs-10"
                    style="font-style: italic;color: #7a7575;"
                  >On behalf of {{shareDetails.user_mail}}</label>
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">To:</label>
                  <div class="emailSelect label-inputs col-sm-10 col-xs-10">
                    <!-- <input
                      v-model="shareDetails.email"
                      type="email"
                      tabindex="2"
                      class="form-control"
                    >-->
                    <multi-select
                      v-model="emailArray"
                      :options="emailOptions"
                      :taggable="true"
                      @tag="addTag"
                      @remove="removeTag"
                      @search-change="addTagInput"
                      @close="callAddTag"
                      :multiple="true"
                      placeholder="Add Email Address"
                      label="name"
                      track-by="name"
                      id="emailSelect"
                      name="email"
                      v-validate="'required|email_invalid_format'"
                      data-vv-as="above"
                      :class="'setEmailDesign'"
                      :close-on-select="false"
                    ></multi-select>
                    <span class="error" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                  
                  </div>
                  <!-- <div class="label-inputs col-sm-1 col-xs-1">
                    <a href.prevent id="appendToEmailAddress">
                      <i class="fa fa-2x fa-plus-circle" style="color: #39b54a;"></i>
                    </a>
                  </div>-->
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">Cc:</label>
                  <div class="emailSelect label-inputs col-sm-10 col-xs-10">
                    <!-- <input
                      v-model="shareDetails.emailcc"
                      type="email"
                      tabindex="3"
                      class="form-control"
                    >-->
                    <multi-select
                      v-model="emailccArray"
                      :options="emailccOptions"
                      :taggable="true"
                      @tag="addTag"
                      @remove="removeTag"
                      @search-change="addTagInput"
                      @close="callAddTag"
                      :multiple="true"
                      placeholder="CC Address"
                      label="name"
                      track-by="name"
                      id="emailccSelect"
                      name="emailCc"
                      v-validate="'email_invalid_format'"
                      :class="'setEmailDesign'"
                      :close-on-select="false"
                    ></multi-select>
                    <span class="error" v-if="errors.has('emailCc')">{{ errors.first('emailCc') }}</span>
                  </div>
                  <div class="col-xs-3 col-sm-3"></div>
                  <!-- <div class="label-inputs col-sm-1 col-xs-1">
                    <a href.prevent id="appendCcEmailAddress">
                      <i class="fa fa-2x fa-plus-circle" style="color: #39b54a;"></i>
                    </a>
                  </div>-->
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">Bcc:</label>
                  <div class="emailSelect label-inputs col-sm-10 col-xs-10">
                    <multi-select
                      v-model="emailbccArray"
                      :options="emailbccOptions"
                      :taggable="true"
                      @tag="addTag"
                      @remove="removeTag"
                      @search-change="addTagInput"
                      @close="callAddTag"
                      :multiple="true"
                      placeholder="BCC Address"
                      label="name"
                      track-by="name"
                      id="emailbccSelect"
                      name="emailBcc"
                      v-validate="'email_invalid_format'"
                      :class="'setEmailDesign'"
                      :close-on-select="false"
                    ></multi-select>
                    <span class="error" v-if="errors.has('emailBcc')">{{ errors.first('emailBcc') }}</span>
                  </div>
                  <div class="col-xs-3 col-sm-3"></div>
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">Subject:</label>
                  <div class="emailSubject label-inputs col-sm-10 col-xs-10">
                    <input
                      v-model="shareDetails.st_notification_subject"
                      type="text"
                      tabindex="4"
                      class="form-control"
                      id="txtEmailSubject"
                      v-validate="'required'"
                      data-vv-as="above"
                      name="subject"
                    />
                    <span class="error" v-if="errors.has('subject')">{{ errors.first('subject') }}</span>
                  </div>
                </div>
                <div class="temp-type form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">Select Template:</label>
                  <multi-select
                    @input="updateSelected"
                    v-model="shareDetails.selected_template"
                    class="label-inputs col-sm-10 col-xs-10"
                    deselect-label="Can't remove this value"
                    :allow-empty="false"
                    :options="['Default','Custom']"
                    :option-height="30"
                  ></multi-select>
                </div>
                <div
                  class="form-group inputWrapper"
                  v-if="shareDetails.selected_template === 'Custom'"
                >
                  <label class="control-label col-sm-2 col-xs-2">Short Codes:</label>
                  <div class="label-inputs col-sm-10 col-xs-10">
                    <span
                      class="scode-span"
                      v-for="scode in shareTemplate.shortcodes"
                      @click="shareDetails.selected_template === 'Default' ? '' : addCodeInMsg($event)"
                    >
                      <label class="scode-label">{{scode.st_shortcode_name}}</label>
                      <span>
                        <i class="code-icon fa fa-plus-circle" aria-hidden="true"></i>
                      </span>
                    </span>
                  </div>
                  <!-- <select size="8" name="selectionField" multiple="yes" :disabled="shareDetails.selected_template === 'Default'">
                    <option v-for="scode in shareTemplate.shortcodes" :key="scode.in_shortcode_id" :value="scode.st_shortcode_name" @dblclick="shareDetails.selected_template === 'Default' ? '' : addCodeInMsg($event)">{{scode.st_shortcode_name}} </option>
                  </select>-->
                </div>
                <div class="form-group inputWrapper">
                  <label class="control-label col-sm-2 col-xs-2">Message:</label>
                  <div class="editorModal label-inputs col-sm-10 col-xs-10">
                    <editor
                      disabled
                      key="editor1"
                      v-if="shareDetails.selected_template === 'Default'"
                      api-key="98eflqojteq83q2disb5x593zm5joehx50cxv42lpoocoblc"
                      ref="tinyEditor"
                      name="email_msg"
                      v-model="shareDetails.st_email_message"
                      v-validate="'required'"
                      data-vv-as="above"
                      :init="{readonly:true,plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help code',toolbar1: 'fontselect | fontsizeselect | formatselect | bold italic underline strikethrough forecolor backcolor | numlist bullist outdent indent  | link code textpattern image | alignleft aligncenter alignright alignjustify | removeformat',relative_urls : false,remove_script_host : false,convert_urls : false,selector: '#txtEmailMessage',height: 250,menubar: false, branding: false}"
                    ></editor>
                    <editor
                      key="editor2"
                      v-else
                      api-key="98eflqojteq83q2disb5x593zm5joehx50cxv42lpoocoblc"
                      ref="tinyEditor"
                      name="email_msg"
                      v-model="shareDetails.st_email_message"
                      v-validate="'required'"
                      data-vv-as="above"
                      :init="{plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help code',toolbar1: 'fontselect | fontsizeselect | formatselect | bold italic underline strikethrough forecolor backcolor | numlist bullist outdent indent  | link code textpattern image | alignleft aligncenter alignright alignjustify | removeformat',relative_urls : false,remove_script_host : false,convert_urls : false,selector: '#txtEmailMessage',height: 250,menubar: false, branding: false}"
                    ></editor>
                    <span
                      class="error"
                      v-if="errors.has('email_msg')"
                    >{{ errors.first('email_msg') }}</span>
                  </div>
                </div>
                <hr />
                <!-- <div class="modal-footer"> -->
                <div class="survey_settings row">
                  <div class="col-md-6">
                    <div class="end_save_btn save_reset">
                      <a class="btn-reset"
                        href="#"
                        name="btnPreviewMail"
                        @click.prevent="showPreview()"
                        id="btnPreviewMail"
                      >
                        <span>Preview Email</span>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="end_save_btn save_cancel">
                      <a class="btn-cancel"
                        href="#"
                        id="closePopUp"
                        @click.prevent="closePopUp"
                        data-dismiss="modal"
                      >cancel</a>
                      <a class="btn-whitelable" href="#" name="btnSendMail" @click.prevent="sendMail()" id="btnSendMail">
                        <span>Send Email</span>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- <button
                    id="closePopUp"
                    type="button"
                    @click.prevent="closePopUp"
                    class="btn btn-cancel"
                    data-dismiss="modal"
                  >Cancel</button>
                  <button
                    type="submit"
                    name="btnPreviewMail"
                    @click.prevent="showPreview()"
                    id="btnPreviewMail"
                    class="btn btn-ok"
                  >Preview Email</button>
                  <button
                    type="submit"
                    name="btnSendMail"
                    @click.prevent="sendMail()"
                    id="btnSendMail"
                    class="btn btn-ok"
                >Send Email</button>-->
                <!-- </div> -->
              </form>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-modal>
    <!-- Email Preview Modal -->
    <b-modal ref="mailPreview" id="mailPreview" title="Email Message Body" ok-only>
      <div class="row">
        <div class="col-sm-2 col-xs-2 marginB10">
          <label>Subject:</label>
          <!-- <span class="hidden-xs pull-right">:</span> -->
        </div>
        <div
          class="col-sm-10 col-xs-10 marginB10 textBreakWord"
        >{{shareDetails.st_notification_subject}}</div>
      </div>
      <div class="row">
        <div class="col-sm-2 col-xs-2 marginB10">
          <label>Message:</label>
        </div>
        <div
          class="col-sm-10 col-xs-10 marginB10 textBreakWord overflowMessage"
          id="emailMessageBody"
        >
          <div class="border-with-padding" v-bar="{preventParentScroll: true}">
            <p v-html="shareDetails.st_email_message_code"></p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import MultiSelect from "vue-multiselect";
import { EventBus } from "../../main";
var {
  queTypeConfig,
  frontHostName,
  constantCommonConfig
} = require("../../../config/config.js");

var Editor = require("@tinymce/tinymce-vue").default;
export default {
  name: "topbar",
  props: {
    showTracey: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultiSelect,
    Editor
  },
  data() {
    return {
      sessionData: [],
      previewLink: "",
      responseLink: "",
      assignUsersLink: "",
      surveySettingsLink: "",
      shareDetails: {},
      // editorDisabled: false,
      // editor: ClassicEditor,
      // editorConfig: {
      //   // toolbar: ['fontfamily','fontsize','heading','bold', 'italic' ]
      // },
      emailOptions: [],
      emailccOptions: [],
      emailbccOptions: [],
      emailArray: [],
      emailccArray: [],
      emailbccArray: [],
      emailsArray: [],
      emailsccArray: [],
      emailsbccArray: [],
      // editorObj: [],
      searchTag: "",
      searchId: "",
      vueCommonConfig: constantCommonConfig,
      emailsValidateArray : [],
      customErr : '',
      aiButImg: require("../../assets/images/ai_but.png"),
      questionPanelActive: false
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["all","photoQuestionCount", "kioskQueCounter"]),
    ...mapGetters("editquestion", ["shareTemplate", "emailSent"]),
    ...mapGetters("editquestionEdit", {
      surveyInAudit: "surveyAudit",
      surveyQuestWithDetails: "getSurveyQuestWithDetails",
      loadingSurveyDetails: "loadingAllSurveyDetails",
      questUpdated: "questionUpdated",
      isSkipLogic: "isSkipLogic"
    })
  },
  async mounted() {
    EventBus.$on("questionTypeSelected", this.onQuestionTypeSelected);
    this.sessionData = this.$session.getAll();
    this.sessionData["in_survey_Id"] = this.$route.params.id;
    var whiteLabel = location.href.split("/")[3];
    this.previewLink =
      location.protocol +
      "//" +
      location.host +
      "/" +
      whiteLabel +
      "/previewform/" +
      this.$route.params.id;
    this.responseLink =
      location.protocol +
      "//" +
      location.host +
      "/" +
      whiteLabel +
      "/responseform/" +
      this.$route.params.id;

    this.assignUsersLink = frontHostName + process.env.CAKE_BASE_PATH + whiteLabel + '/forms/assignusers/' + this.$route.params.id + '?type=1'
    this.surveySettingsLink = frontHostName + process.env.CAKE_BASE_PATH + whiteLabel + '/forms/formsettings/' + this.$route.params.id
    // this.previewLink =
    //   location.href + "/previewsurvey/" + this.$route.params.id;
    // this.responseLink =
    //   location.href + "/responsesurvey/" + this.$route.params.id;

    this.$validator.extend("email_invalid_format", {
      getMessage: () => {
        return this.customErr;
      },
      validate: (value, args) => {
        let emailMessage = value[value.length-1];
        if(emailMessage.validate == "invalid")
        {
          this.customErr = "This email is invalid- " + emailMessage.name;
        }
        else
        {
          var lastIndex =value.map(s => s.validate === "invalid").lastIndexOf(true);
          let emailMessage2 = value[lastIndex];
          this.customErr = "This email is invalid- " + emailMessage2.name;
        }
        return false;
      }
    });

    this.$validator.extend("email_invalid_format2", {
      getMessage: () => {
        return "";
      },
      validate: () => {
        return false;
      }
    });

    this.$validator.extend("email_valid_format", {
      validate: () => {
        return true;
      }
    });
  },
  methods: {
    ...mapActions("LeftSidebarCreate", ["setSurvey_name"]),
    ...mapActions("editquestionEdit", [
      "isSurveyQuestioninAudit",
      "removeEmptyQueSurvey"
    ]),
    ...mapActions("editquestion", ["getShareTemplate", "saveSendMail"]),
    updateSurvey_name(e) {
      e.target.value = e.target.value.trim();
      if (
        e.target.value &&
        e.target.value.length >= 6 &&
        e.target.value.length <= 255
      ) {
        this.setSurvey_name([e.target.value, this.sessionData]);
      } else {
        e.target.value = this.all.st_survey_name;
        this.$awn.alert(
          "Form Name should have atleast 6 characters & atmost 255 characters"
        );
      }
    },
    callSaveMethod: function() {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function() {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    },
    async exitVue() {
      // Delete survey details if no questions found in draft survey
      if (this.all.in_status == constantCommonConfig.SURVEY_DRAFT) {
        this.$wait.start("topbarloader");
        await this.removeEmptyQueSurvey(this.sessionData).then(value => {
          this.$wait.end("topbarloader");
        });
      }
      this.$session.remove("in_survey_Id");
      // var parts = window.location.href.split(".");
      if (!window.close()) {
        let whitelabel = this.$session.get("whitelabel");
        var loc =
          frontHostName +
          process.env.CAKE_BASE_PATH +
          whitelabel +
          process.env.CAKE_SURVEY_PATH;
        location.href = loc;
      }
    },
    previewWindow() {
      let isNotStartEnd = 0;
      if (
        Object.keys(this.surveyQuestWithDetails).length > 0 &&
        Object.keys(this.surveyQuestWithDetails).length <= 2
      ) {
        Object.keys(this.surveyQuestWithDetails).forEach((key, index) => {
          if (
            this.surveyQuestWithDetails[key][
              Object.keys(this.surveyQuestWithDetails[key])[0]
            ]["in_question_type_id"] != queTypeConfig.TYPE_START_SCREEN_TEXT &&
            this.surveyQuestWithDetails[key][
              Object.keys(this.surveyQuestWithDetails[key])[0]
            ]["in_question_type_id"] != queTypeConfig.TYPE_END_SCREEN_TEXT
          )
            isNotStartEnd = 1;
        });
        if (isNotStartEnd === 1) window.open(this.previewLink, "_blank");
        else this.$awn.alert("Form should have atleast 1 question.");
        return false;
      } else if (Object.keys(this.surveyQuestWithDetails).length > 2) {
        window.open(this.previewLink, "_blank");
      } else {
        this.$awn.alert("Form should have atleast 1 question.");
        return false;
      }
    },
    async validatePublish() {
      if (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED) {
        this.sessionData["in_survey_type"] = this.all.in_survey_type;
        this.sessionData["in_audit"] = this.all.in_audit;
        // Check there is an issue in audit score (Orange color icon)
        var orangeColorClass = document.querySelectorAll(".survey_colume_2 .question_option .modalOrange");
        if(orangeColorClass.length > 0) {
          this.$awn.alert("There's an issue with one of your audit scores. Click on the orange icon to rectify.");
          return false;
        }
        await this.isSurveyQuestioninAudit(this.sessionData).then(() => {
          if (this.surveyInAudit === -4) {
            this.$awn.alert(
              "You have marked the only mobile supported questions as mandatory, please select anyone for the online form also"
            );
          }  else if ( this.all.in_survey_type == 4 && this.kioskQueCounter > 1) {
            this.$awn.alert(
              "Only one question allowed in kiosk mode."
            );
          } else if (this.all.in_survey_type == 4 && this.surveyInAudit === -5) {
            this.$awn.alert(
              "Invalid question for kiosk mode."
            );
          } else if ( this.all.in_survey_type == 4 && this.surveyInAudit === -3) {
            this.$awn.alert(
              "The question must be mandatory."
            );
          } else if (this.surveyInAudit === -3) {
            this.$awn.alert(
              "There should be at least question mandatory"
            );
          } else if (this.surveyInAudit === -2) {
            this.$awn.alert(
              "There should be at least one input question in form"
            );
          } else if (this.surveyInAudit === 0) {
            this.$awn.alert(
              "There should be at least one question with audit score enabled"
            );
          } else if (this.surveyInAudit === -1) {
            this.$awn.alert(
              "Photo, Audio, Video and QR & Barcode Scanner type questions are not allowed in online form types."
            );
          } else if(this.photoQuestionCount > 50) {
            this.$awn.alert(
              "Only 50 Photo Questions allowed."
            );
          } else if (this.surveyInAudit === 2) {
            this.$awn.alert(
              "There is some issue in adding address details in questions."
            );
          } else if (this.surveyInAudit === 1) {
            this.$awn.success("Form published");
            // var parts = window.location.href.split(".");
            let whitelabel = this.$session.get("whitelabel");
            window.localStorage.removeItem("datatables_managesurvey");
            var loc =
              frontHostName +
              process.env.CAKE_BASE_PATH +
              whitelabel +
              process.env.CAKE_SURVEY_NEW_PATH;
            window.location.href = loc;
          }
        });
      } else {
        if (!window.close()) {
          let whitelabel = this.$session.get("whitelabel");
          window.localStorage.removeItem("datatables_managesurvey");
          var loc =
            frontHostName +
            process.env.CAKE_BASE_PATH +
            whitelabel +
            process.env.CAKE_SURVEY_NEW_PATH;
          window.location.href = loc;
        }
      }
    },
    async shareSurvey() {
      let shareData = this.sessionData;
      shareData.baseUrl = location.href + this.$router.currentRoute.fullPath;
      await this.getShareTemplate(shareData).then(() => {
        this.closePopUp();
        this.$set(
          this.shareDetails,
          "st_notification_subject",
          this.shareTemplate.data.st_notification_subject
        );
        this.$set(
          this.shareDetails,
          "st_email_message",
          this.shareTemplate.data.st_email_message
        );
        this.$set(
          this.shareDetails,
          "company_details",
          this.shareTemplate.data.company_details
        );
        this.$set(
          this.shareDetails,
          "codeDetails",
          this.shareTemplate.data.codeDetails
        );
        this.$set(
          this.shareDetails,
          "user_mail",
          this.shareTemplate.data.user_mail
        );
        this.shareDetails.selected_template = "Default";
        // this.editorDisabled = true;
        this.$refs.myModalRef.show();
      });
    },
    copyText() {
      var copyText = document.getElementById("shareLink");
      copyText.select();
      document.execCommand("copy");
    },
    updateSelected() {
      if (this.shareTemplate.data.in_notification_id) {
        if (this.shareDetails.selected_template === "Custom") {
          this.shareDetails.st_notification_subject = "";
          this.shareDetails.st_email_message = "";
          // this.editorDisabled = false;
        } else if (this.shareDetails.selected_template === "Default") {
          // this.editorDisabled = true;
          this.shareDetails.st_notification_subject = this.shareTemplate.data.st_notification_subject;
          this.shareDetails.st_email_message = this.shareTemplate.data.st_email_message;
        }
      }
    },
    async closePopUp(e) {
      this.shareDetails = {};
      this.emailsArray = [];
      this.emailOptions = [];
      this.emailArray = [];
      this.emailsArray = [];
      this.emailccArray = [];
      this.emailsccArray = [];
      this.emailccOptions = [];
      this.emailbccArray = [];
      this.emailsbccArray = [];
      this.emailbccOptions = [];
      this.emailsValidateArray = [];
      this.ccEmailsValidateArray = [];
      this.bccEmailsValidateArray = [];
      this.$validator.reset();
      // this.editorDisabled = false;
      // Hide popup if cancel button was clicked as also called whenever the modal is opened
      if (e && e.target.id === "closePopUp") this.$refs.myModalRef.hide();
    },
    async addTag(newTag, id) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };

      var combineEmail = [] ; 
      var fieldName = "";
      if (id == "emailSelect") {
        combineEmail = this.emailsValidateArray;
        fieldName = "email";
      } else if (id == "emailccSelect") {
        combineEmail = this.ccEmailsValidateArray;
        fieldName = "emailCc";
      } else if (id == "emailbccSelect") {
        combineEmail = this.bccEmailsValidateArray;
        fieldName = "emailBcc";
      }

      const field = this.$validator.fields.find({ name: fieldName }); 
      if(newTag != "" && combineEmail.length == 0)
      {
        field.update({ rules: 'email_invalid_format2' });  
      }

      if (re.test(String(newTag).toLowerCase())) {

        if (id == "emailSelect") {
          var found = this.emailArray.some(el => el.name === newTag);
          if (!found)
          {
            this.emailOptions.push(tag);
            this.emailArray.push(tag);
            this.emailsArray.push(newTag);
          }
        } else if (id == "emailccSelect") {
          var found = this.emailccArray.some(el => el.name === newTag);
          if (!found)
          {
            this.emailccOptions.push(tag);
            this.emailccArray.push(tag);
            this.emailsccArray.push(newTag);
          }
        } else if (id == "emailbccSelect") {
          var found = this.emailbccArray.some(el => el.name === newTag);
          if (!found)
          {
            this.emailbccOptions.push(tag);
            this.emailbccArray.push(tag);
            this.emailsbccArray.push(newTag);
          }
        }

        // Check email validation usig sendgrid/Zerobounce
        var url = process.env.API_PATH + '/checkAPIEmailValidationWeb';
        async function emailvalidation() { 
          let checkemailvalidation = await axios
            .post(
              url,
              {
                email: newTag,
                source: 'Shared Form vue',
              },
              {
                headers: { 'Content-Type': 'application/json' }
              }
            );
          return checkemailvalidation.data;
        }

        let emailValidate = await emailvalidation();
        // field.update({ rules: 'email_invalid_format2' });
        if(emailValidate.flag == true && emailValidate.emailIsvalid == false)
        {
          tag['validate'] = "invalid";
          combineEmail.push({ "newTag" : newTag, 'code': tag.code, 'validate' : 'invalid' });
          field.update({ rules: 'email_invalid_format' });
        }
        else
        {
          tag['validate'] = "valid";
          const filteredEmail = combineEmail.filter((item) => item.newTag !== "");
          const isFound = filteredEmail.some(element => {
            if (element.validate === "invalid") {
              return true;
            }
          });
          if(isFound == false)
          {
            field.update({ rules: 'email_valid_format' });
          }
        }

      } else {
        if(newTag != "")
        {
          tag['validate'] = "invalid";
          field.update({ rules: 'email_invalid_format' });
          if (id == "emailSelect") {
            var found = this.emailArray.some(el => el.name === newTag);
            if (!found)
            {
              this.emailOptions.push(tag);
              this.emailArray.push(tag);
              this.emailsArray.push(newTag);
            }
          } else if (id == "emailccSelect") {
            var found = this.emailccArray.some(el => el.name === newTag);
            if (!found)
            {
              this.emailccOptions.push(tag);
              this.emailccArray.push(tag);
              this.emailsccArray.push(newTag);
            }
          } else if (id == "emailbccSelect") {
            var found = this.emailbccArray.some(el => el.name === newTag);
            if (!found)
            {
              this.emailbccOptions.push(tag);
              this.emailbccArray.push(tag);
              this.emailsbccArray.push(newTag);
            }
          }
        }
        
        combineEmail.push({ "newTag" : newTag, 'code': tag.code, 'validate' : 'invalid' });
      }

      this.searchTag = "";
      this.searchId = "";
    },
    addTagInput(val, id) {
      this.searchTag = val;
      this.searchId = id;
    },
    removeTagValidate(filteredEmail, emailsValidateArray, id) {
      var fieldName = "";
      if (id == "emailSelect") {
        fieldName = "email";
      } else if (id == "emailccSelect") {
        fieldName = "emailCc";
      } else if (id == "emailbccSelect") {
        fieldName = "emailBcc";
      }

      const field = this.$validator.fields.find({ name: fieldName }); 
      const isFound = filteredEmail.some(element => {
          if (element.validate === "invalid") {
            return true;
          }
        });

        if(isFound == false)
        {
          field.update({ rules: 'email_valid_format' });
          if (id == "emailSelect") 
          {
            if(emailsValidateArray.length <= 0)
            {
              field.update({ rules: 'required' });
            }
          }
        }
    },
    removeTag(tag, id) {

      if (id == "emailSelect") {
        this.emailArray = this.emailArray.filter(e => e !== tag.name);
        this.emailsArray = this.emailsArray.filter(e => e !== tag.name);
        this.emailsValidateArray = this.emailsValidateArray.filter(function (el){
          return el.newTag !== tag.name;
        });

        const filteredEmail = this.emailsValidateArray.filter((item) => item.newTag !== "");
        this.removeTagValidate(filteredEmail, this.emailsValidateArray, "emailSelect");

      } else if (id == "emailccSelect") {
        this.emailccArray = this.emailccArray.filter(e => e !== tag.name);
        this.emailsccArray = this.emailsccArray.filter(e => e !== tag.name);

        this.ccEmailsValidateArray = this.ccEmailsValidateArray.filter(function (el){
          return el.newTag !== tag.name ;
        });

        const ccfilteredEmail = this.ccEmailsValidateArray.filter((item) => item.newTag !== "");
        this.removeTagValidate(ccfilteredEmail, this.ccEmailsValidateArray, "emailccSelect");
      } else if (id == "emailbccSelect") {
        this.emailbccArray = this.emailbccArray.filter(e => e !== tag.name);
        this.emailsbccArray = this.emailsbccArray.filter(e => e !== tag.name);

        this.bccEmailsValidateArray = this.bccEmailsValidateArray.filter(function (el){
          return el.newTag !== tag.name ;
        });

        const bccfilteredEmail = this.bccEmailsValidateArray.filter((item) => item.newTag !== "");
        this.removeTagValidate(bccfilteredEmail, this.bccEmailsValidateArray, "emailbccSelect");
      }
    },
    callAddTag() {
      this.addTag(this.searchTag, this.searchId);
    },
    sendMail() {
      this.$validator.validateAll().then(() => {
        if (this.errors.items.length === 0) {
          let sendMailData = { ...this.sessionData, ...this.shareDetails };
          sendMailData.in_notification_id =
            this.shareDetails.selected_template === "Default"
              ? this.shareTemplate.data.in_notification_id
              : -1;
          sendMailData.emailsArray = this.emailsArray;
          sendMailData.emailsccArray = this.emailsccArray;
          sendMailData.emailsbccArray = this.emailsbccArray;
          // Replace shortcodes before sending email
          sendMailData.st_email_message_code = sendMailData.st_email_message.replace(
            /\[FormName\]/g,
            sendMailData.codeDetails.st_survey_name
          );
          sendMailData.st_email_message_code = sendMailData.st_email_message_code.replace(
            /\[FormDate\]/g,
            sendMailData.codeDetails.dt_published_at
          );
          sendMailData.st_email_message_code = sendMailData.st_email_message_code.replace(
            /\[FormLink\]/g,
            this.responseLink
          );
          sendMailData.st_email_message_code = sendMailData.st_email_message_code.replace(
            /\[FormVersion\]/g,
            sendMailData.codeDetails.in_versionno
          );
          this.saveSendMail(sendMailData).then(() => {
            if (this.emailSent) this.$awn.success("Email sent");
            else this.$awn.alert("There is some problem in sending mail");
          });
          this.$refs.myModalRef.hide();
        }
      });
    },
    addCodeInMsg(e) {
      if (e.target.className.includes("code-icon")) {
        tinymce.activeEditor.insertContent(
          e.target.parentElement.parentElement.children[0].innerText
        );
      } else {
        tinymce.activeEditor.insertContent(
          e.target.parentElement.children[0].innerText
        );
      }
    },
    showPreview() {
      this.replaceCodes();
      this.$refs.mailPreview.show();
    },
    replaceCodes() {
      // Replace shortcodes before sending email
      let temp_msg = "";
      temp_msg = this.shareDetails.st_email_message.replace(
        /\[FormName\]/g,
        this.shareDetails.codeDetails.st_survey_name
      );
      temp_msg = temp_msg.replace(
        /\[FormDate\]/g,
        this.shareDetails.codeDetails.dt_published_at
      );
      temp_msg = temp_msg.replace(/\[FormLink\]/g, this.responseLink);
      temp_msg = temp_msg.replace(
        /\[FormVersion\]/g,
        this.shareDetails.codeDetails.in_versionno
      );
      this.$set(this.shareDetails, "st_email_message_code", temp_msg);
    },
    headerScroll(evt) {
      // EventBus.$emit(
      //   "calculateScrollY",
      //   this.$vuebar.getState(this.$refs.vuebarContainer).barTop
      // );
    },
    onQuestionTypeSelected(qtype) {
      if (!qtype) {
        this.questionPanelActive = false;
        return;
      }
      if (qtype.qid) {
        this.questionPanelActive = true;
        return;
      }
      if (qtype.id == "17" || qtype.id == "18") {
        this.questionPanelActive = true;
        return;
      }
      this.questionPanelActive = false;
    },
    triggerQuestionSave() {
      EventBus.$emit("triggerQuestionSave");
    }
  },
  beforeDestroy() {
    EventBus.$off("questionTypeSelected", this.onQuestionTypeSelected);
  }
};
</script>

<style>
/* Header action row: consistent alignment for publish, preview, Tracey, close */
.content_bg .survey_head_row .survey_head_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.content_bg .survey_head_row .survey_head_right > .topheaderdropdown {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler:not(.btn-tracey-ai) {
  overflow: hidden;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler {
  box-sizing: border-box;
  flex-shrink: 0;
  justify-content: center;
  line-height: 1;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler > i {
  flex-shrink: 0;
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  margin: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-header-question-save {
  color: #040404;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-header-question-save > svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  display: block;
  margin: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-header-question-save:hover {
  color: #ffffff;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler > span:not(.btn-tracey-ai__icon-slot) {
  display: none;
  width: 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  line-height: 40px;
  padding-left: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler:hover {
  justify-content: flex-start;
  padding: 0 12px 0 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler:hover > i {
  width: 40px;
  min-width: 40px;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-header-question-save:hover > svg {
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin: 0 0 0 12px;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-survey-reguler:hover > span:not(.btn-tracey-ai__icon-slot) {
  display: inline-block;
  width: auto;
  flex: 1;
  min-width: 0;
  padding-left: 0;
  animation: rightToleft ease-in 0.5s;
}

.content_bg .survey_head_row .survey_head_right .topheaderdropdown .dropdown-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.content_bg .survey_head_row .survey_head_right .topheaderdropdown .dropdown-toggle svg {
  display: block;
  margin: 0 auto;
}

/* Tracey button: full multicolor ring + visible icon slot */
.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai {
  position: relative;
  overflow: hidden;
  background: transparent !important;
  isolation: isolate;
  display: flex;
  align-items: center;
  height: 40px;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: conic-gradient(
    from 0deg,
    #ff006e,
    #8338ec,
    #3a86ff,
    #06ffa5,
    #ffbe0b,
    #fb5607,
    #ff006e
  );
  animation: tracey-btn-spin 2.5s linear infinite;
  z-index: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: inherit;
  background: #e6e7e8;
  z-index: 1;
  transition: inset 0.5s ease-out, background 0.5s ease-out;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai > .btn-tracey-ai__icon-slot {
  position: relative;
  z-index: 2;
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai > .btn-tracey-ai__icon-slot .btn-tracey-ai__icon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  fill: currentColor;
  flex-shrink: 0;
  transition: filter 0.5s ease-out;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai > .btn-tracey-ai__icon-slot .btn-tracey-ai__face {
  width: 24px;
  height: 24px;
  display: none;
  object-fit: cover;
  border-radius: 999px;
  flex-shrink: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai > span:not(.btn-tracey-ai__icon-slot) {
  position: relative;
  z-index: 2;
  color: #040404;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover {
  width: 140px;
  height: 40px;
  align-items: center;
  justify-content: flex-start;
  padding: 0 12px 0 0;
  color: #ffffff;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover > .btn-tracey-ai__icon-slot {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover > span:not(.btn-tracey-ai__icon-slot) {
  display: inline-block;
  width: auto;
  flex: 1;
  min-width: 0;
  padding-left: 0;
  line-height: 40px;
  color: #ffffff;
  animation: rightToleft ease-in 0.5s;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover .btn-tracey-ai__icon {
  filter: brightness(0) invert(1);
  display: none;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover .btn-tracey-ai__face {
  display: block;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover::before {
  animation: none;
  opacity: 0;
}

.content_bg .survey_head_row .survey_head_right button.btn.btn-tracey-ai:hover::after {
  inset: 0;
  background: #71439b;
}

@keyframes tracey-btn-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/topbar.vue